import { Drop } from "../types";

export const DROPS: Drop[] = [
  {
    id: 1,
    title: "The Amy Walk",
    subtitle: "Amy Winehouse · Camden",
    inspo: "Through the streets where Amy grew up, busked, and became a legend. Past the Hawley Arms, Camden Market, and her old flat on Jeffrey's Place.",
    emoji: "🖤",
    cardBg: "#FFF0F3", cardBorder: "#F5DDD9", accentColor: "#C9184A", tagBg: "#C9184A",
    distance: "2.4 mi", time: "38 min", neighbourhood: "Camden, NW1",
    landmarks: ["Hawley Arms", "Camden Market", "Jeffrey's Place", "Roundhouse"],
    playlistName: "Back to Black Era", playlistEmoji: "🖤",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4OzrY981I1W",
    songs: ["Rehab – Amy Winehouse", "Valerie – Amy Winehouse", "Tears Dry on Their Own", "Back to Black", "Stronger Than Me"],
    bpm: "95 BPM · Soul / Jazz", isLimited: true, expiresIn: "3d 14h", tag: "THIS WEEK'S DROP",
    waypoints: [
      { lat: 51.5414, lng: -0.1434, label: "Start: Camden Town Station" },
      { lat: 51.5423, lng: -0.1467, label: "Hawley Arms" },
      { lat: 51.5441, lng: -0.1488, label: "Camden Market" },
      { lat: 51.5388, lng: -0.1452, label: "Jeffrey's Place" },
      { lat: 51.5427, lng: -0.1523, label: "Roundhouse" },
    ],
  },
  {
    id: 2,
    title: "The Fleabag Route",
    subtitle: "Phoebe Waller-Bridge · Hammersmith",
    inspo: "Walk the actual streets from Fleabag. The cafe, the river, the walk of shame home. Chaotic, brilliant, very London.",
    emoji: "☕",
    cardBg: "#FFF8F0", cardBorder: "#FFD9A8", accentColor: "#B5621E", tagBg: "#B5621E",
    distance: "1.8 mi", time: "28 min", neighbourhood: "Hammersmith, W6",
    landmarks: ["Ravenscourt Park", "King Street", "Hammersmith Bridge", "The Dove Pub"],
    playlistName: "Messy & Iconic", playlistEmoji: "🍷",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX1BzILRveYHb",
    songs: ["Woman – Doja Cat", "Foundations – Kate Nash", "Naive – The Kooks", "F**k You – Lily Allen", "Villain – Lily Allen"],
    bpm: "105 BPM · Indie / Alt", isLimited: true, expiresIn: "5d 2h", tag: "TRENDING 🔥",
    waypoints: [
      { lat: 51.4927, lng: -0.2339, label: "Start: Hammersmith Station" },
      { lat: 51.4913, lng: -0.2362, label: "King Street" },
      { lat: 51.4896, lng: -0.2289, label: "Hammersmith Bridge" },
      { lat: 51.4934, lng: -0.2254, label: "The Dove Pub" },
      { lat: 51.4941, lng: -0.2334, label: "Ravenscourt Park" },
    ],
  },
  {
    id: 3,
    title: "The Notting Hill Strut",
    subtitle: "Julia Roberts · Portobello Road",
    inspo: "Portobello Road on a Saturday morning, the blue door, the flower stalls. Pure rom-com fantasy.",
    emoji: "🌸",
    cardBg: "#F0FFF4", cardBorder: "#C8E6C9", accentColor: "#0A7C5E", tagBg: "#0A7C5E",
    distance: "2.1 mi", time: "34 min", neighbourhood: "Notting Hill, W11",
    landmarks: ["Portobello Road Market", "The Blue Door", "Electric Cinema", "Westbourne Grove"],
    playlistName: "Soft Girl London", playlistEmoji: "🌸",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX9wC1KY45plY",
    songs: ["She – Elvis Costello", "Sweater Weather – The Neighbourhood", "Heather – Conan Gray", "Golden – Harry Styles", "Waterloo Sunset – The Kinks"],
    bpm: "85 BPM · Soft Indie", isLimited: false, expiresIn: "", tag: "FAN FAVOURITE",
    waypoints: [
      { lat: 51.5094, lng: -0.2018, label: "Start: Notting Hill Gate Station" },
      { lat: 51.5136, lng: -0.2045, label: "Portobello Road Market" },
      { lat: 51.5152, lng: -0.2021, label: "The Blue Door" },
      { lat: 51.5118, lng: -0.1989, label: "Electric Cinema" },
      { lat: 51.5101, lng: -0.1967, label: "Westbourne Grove" },
    ],
  },
  {
    id: 4,
    title: "The Crown Walk",
    subtitle: "Royal London · Kensington",
    inspo: "Kensington Palace, Hyde Park, The Serpentine. Walk like you own the city — because for the next 50 minutes, you do.",
    emoji: "👑",
    cardBg: "#F3F0FF", cardBorder: "#D9D0F5", accentColor: "#5B45D4", tagBg: "#5B45D4",
    distance: "3.2 mi", time: "50 min", neighbourhood: "Kensington, W8",
    landmarks: ["Kensington Palace", "Hyde Park", "The Serpentine", "Albert Memorial"],
    playlistName: "Main Character Era", playlistEmoji: "👑",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX1BzILRveYHb",
    songs: ["Royals – Lorde", "Run the World – Beyoncé", "Power – Kanye West", "Flawless – Beyoncé", "Queen – Perfume Genius"],
    bpm: "118 BPM · Pop / R&B", isLimited: false, expiresIn: "", tag: "LONDON CLASSIC",
    waypoints: [
      { lat: 51.5051, lng: -0.1877, label: "Start: High Street Kensington" },
      { lat: 51.5051, lng: -0.1877, label: "Kensington Palace" },
      { lat: 51.5074, lng: -0.1758, label: "The Serpentine Gallery" },
      { lat: 51.5049, lng: -0.1637, label: "Hyde Park Corner" },
      { lat: 51.5012, lng: -0.1791, label: "Albert Memorial" },
    ],
  },
  {
    id: 5,
    title: "The Bridget Jones",
    subtitle: "Borough Market · South Bank",
    inspo: "Borough Market at golden hour, across London Bridge, along the South Bank. Total chaotic-hopeful-romantic London energy.",
    emoji: "📔",
    cardBg: "#FFF0F3", cardBorder: "#F5DDD9", accentColor: "#C9184A", tagBg: "#C9184A",
    distance: "2.6 mi", time: "42 min", neighbourhood: "Southwark, SE1",
    landmarks: ["Borough Market", "London Bridge", "Tate Modern", "South Bank"],
    playlistName: "Hopeless Romantic", playlistEmoji: "💌",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX9wC1KY45plY",
    songs: ["All By Myself – Celine Dion", "Someone Like You – Adele", "Chasing Pavements – Adele", "Fix You – Coldplay", "Don't You Want Me – Human League"],
    bpm: "88 BPM · Pop Classics", isLimited: true, expiresIn: "6d 8h", tag: "NEW DROP ✨",
    waypoints: [
      { lat: 51.5055, lng: -0.0910, label: "Start: London Bridge Station" },
      { lat: 51.5052, lng: -0.0910, label: "Borough Market" },
      { lat: 51.5079, lng: -0.0877, label: "London Bridge" },
      { lat: 51.5076, lng: -0.0994, label: "Tate Modern" },
      { lat: 51.5072, lng: -0.1125, label: "South Bank" },
    ],
  },
  {
    id: 6,
    title: "The Adele Walk",
    subtitle: "Adele · Tottenham & North London",
    inspo: "Through Tottenham and North London where Adele grew up. From council estates to global icon — every step has a story.",
    emoji: "🎤",
    cardBg: "#FFF8F0", cardBorder: "#FFD9A8", accentColor: "#B5621E", tagBg: "#B5621E",
    distance: "2.8 mi", time: "45 min", neighbourhood: "Tottenham, N17",
    landmarks: ["Bruce Grove", "Tottenham High Road", "Chestnuts Park", "North Middlesex"],
    playlistName: "Someone Like You Era", playlistEmoji: "🎤",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4dyzvuaRJ0n",
    songs: ["Hello – Adele", "Rolling in the Deep – Adele", "Someone Like You – Adele", "Skyfall – Adele", "Easy On Me – Adele"],
    bpm: "76 BPM · Soul / Pop", isLimited: false, expiresIn: "", tag: "ICONIC",
    waypoints: [
      { lat: 51.5966, lng: -0.0693, label: "Start: Bruce Grove Station" },
      { lat: 51.5962, lng: -0.0681, label: "Bruce Grove" },
      { lat: 51.5978, lng: -0.0712, label: "Tottenham High Road" },
      { lat: 51.5943, lng: -0.0748, label: "Chestnuts Park" },
      { lat: 51.5921, lng: -0.0701, label: "North Middlesex" },
    ],
  },
  {
    id: 7,
    title: "The Eastenders Walk",
    subtitle: "Bethnal Green & Hackney",
    inspo: "From the flower stalls of Columbia Road to the cool cafes of Broadway Market. Gritty, gorgeous, and so East London.",
    emoji: "🧅",
    cardBg: "#F0FFF4", cardBorder: "#C8E6C9", accentColor: "#0A7C5E", tagBg: "#0A7C5E",
    distance: "2.3 mi", time: "37 min", neighbourhood: "Bethnal Green, E2",
    landmarks: ["Columbia Road Market", "Bethnal Green Gardens", "Broadway Market", "London Fields"],
    playlistName: "East End Energy", playlistEmoji: "🧅",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4dyzvuaRJ0n",
    songs: ["East London – Ed Sheeran", "Naive – The Kooks", "Do I Wanna Know – Arctic Monkeys", "505 – Arctic Monkeys", "Little Things – One Direction"],
    bpm: "108 BPM · Indie / Brit Pop", isLimited: true, expiresIn: "4d 10h", tag: "NEW DROP ✨",
    waypoints: [
      { lat: 51.5289, lng: -0.0788, label: "Start: Bethnal Green Station" },
      { lat: 51.5316, lng: -0.0754, label: "Columbia Road Flower Market" },
      { lat: 51.5276, lng: -0.0592, label: "Broadway Market" },
      { lat: 51.5430, lng: -0.0559, label: "London Fields" },
      { lat: 51.5395, lng: -0.0653, label: "Hackney Central" },
    ],
  },
  {
    id: 8,
    title: "The Shoreditch Strut",
    subtitle: "Street Art & East London Cool",
    inspo: "Brick Lane, street art alleys, vintage markets and the coolest coffee in London. Walk like you discovered it before it was cool.",
    emoji: "🎨",
    cardBg: "#F3F0FF", cardBorder: "#D9D0F5", accentColor: "#5B45D4", tagBg: "#5B45D4",
    distance: "1.9 mi", time: "30 min", neighbourhood: "Shoreditch, E1",
    landmarks: ["Brick Lane", "Boxpark Shoreditch", "Rivington Street Murals", "Old Spitalfields Market"],
    playlistName: "Villain Era", playlistEmoji: "🎨",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4OzrY981I1W",
    songs: ["bad idea right? – Olivia Rodrigo", "vampire – Olivia Rodrigo", "Cruel Summer – Taylor Swift", "Woman – Doja Cat", "Levitating – Dua Lipa"],
    bpm: "122 BPM · Alt Pop", isLimited: false, expiresIn: "", tag: "EAST LONDON",
    waypoints: [
      { lat: 51.5204, lng: -0.0784, label: "Start: Shoreditch High Street" },
      { lat: 51.5215, lng: -0.0718, label: "Brick Lane" },
      { lat: 51.5238, lng: -0.0775, label: "Boxpark Shoreditch" },
      { lat: 51.5247, lng: -0.0812, label: "Rivington Street Murals" },
      { lat: 51.5181, lng: -0.0753, label: "Old Spitalfields Market" },
    ],
  },
];
